var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTenkenWh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_free_tenken_wh",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_12",
    "data-name": "\\u9577\\u65B9\\u5F62 12",
    width: 35,
    height: 35,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_5",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M50.13,48.983a.725.725,0,0,1-.416-.127L47.4,47.316a.751.751,0,1,1,.831-1.251L50,47.242,53.5,43.3a.75.75,0,0,1,1.124.993l-3.933,4.436a.753.753,0,0,1-.56.254Z",
    transform: "translate(-26.474 -24.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M52.371,19.3H46.557v-.884a.748.748,0,0,0-.748-.748H40.869a.748.748,0,0,0-.748.748V19.3h-.28c.013.214.031.424.031.639,0,.289-.022.578-.044.862h1.041a.748.748,0,0,0,.748-.748v-.884h3.439v.884a.748.748,0,0,0,.748.748h1.409v2.6H39.286a11.1,11.1,0,0,1-.608,1.492c.013,0,.022,0,.031,0h9.257a.748.748,0,0,0,.748-.748V23.3h.407V40.188H37.553V26.665a10.938,10.938,0,0,1-1.5,1.584V40.936a.748.748,0,0,0,.748.748H49.869a.748.748,0,0,0,.748-.748V22.552a.748.748,0,0,0-.748-.748H48.714v-1h2.905V42.691H35.051V29.032a11.22,11.22,0,0,1-1.5.849V43.443a.748.748,0,0,0,.748.748H52.367a.748.748,0,0,0,.748-.748V20.05a.748.748,0,0,0-.748-.748Z",
    transform: "translate(-18.872 -9.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M28.048,15.074c-1.072,0-1.7,1.138-1.7,3.093,0,2.148.582,3.251,1.711,3.251s1.684-1.081,1.684-3.216-.591-3.132-1.7-3.132Z",
    transform: "translate(-14.822 -8.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM7.472,10.36a4.14,4.14,0,0,0,.814-.066v1.081a4.831,4.831,0,0,0-.814-.057H6.615l-.267.446v.162H7.459a4.054,4.054,0,0,0,.814-.066v1.081a5.2,5.2,0,0,0-.814-.057H6.348v.346a8.974,8.974,0,0,0,.061,1.19H4.778a10.461,10.461,0,0,0,.061-1.19v-.346H3.7a4.837,4.837,0,0,0-.823.057V11.861a3.845,3.845,0,0,0,.823.066H4.839v-.162l-.258-.446H3.714a4.288,4.288,0,0,0-.818.057V10.294a3.933,3.933,0,0,0,.818.066h.319L3.084,8.737c-.158-.28-.455-.752-.608-.967H4.353a4.171,4.171,0,0,0,.35.84l.888,1.767.9-1.767a4.1,4.1,0,0,0,.35-.84H8.706c-.136.206-.529.849-.6.967L7.166,10.36h.311Zm9.083,2.752a3.69,3.69,0,0,1-3.329,1.873,3.684,3.684,0,0,1-2.756-1.116,3.794,3.794,0,0,1-.831-1.33,8.318,8.318,0,0,1-.446-2.748,7.3,7.3,0,0,1,.717-3.321,3.667,3.667,0,0,1,3.316-1.894,3.7,3.7,0,0,1,3.6,2.446,8.333,8.333,0,0,1,.446,2.756,7.367,7.367,0,0,1-.717,3.334Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTenkenWh);
export default __webpack_public_path__ + "static/media/icon_tenken_wh.0dfc1c59b185b94cb043292bee022931.svg";
export { ForwardRef as ReactComponent };